module.exports = __webpack_public_path__ + "img/loading.e366b711.gif";